import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Box from '../Box';
import Flex from '../Flex';

const LeftBox = styled(Box)`
  flex: 0 0 auto;
`;

const Layout = ({
  top,
  main,
  left,
  right,
  bottom,
  mainTop,
  mainBottom,
  mainProps,
  leftProps,
  rightProps,
  bottomProps,
  topProps,
  mainTopProps,
  mainBottomProps,
  mainMiddleProps,
  innerContainerProps,
  outerContainerProps,
}) => {
  return (
    <Box {...outerContainerProps}>
      {top && <Box {...topProps}>{top}</Box>}
      <Flex width={1} alignItems={'stretch'} {...innerContainerProps}>
        {left && <LeftBox {...leftProps}>{left}</LeftBox>}
        {main && (
          <Flex flexDirection={'column'} flex={'1 1 auto'} {...mainProps}>
            {mainTop && (
              <Box flex={'0 0 auto'} {...mainTopProps}>
                {mainTop}
              </Box>
            )}
            {mainTop || mainBottom ? (
              <Box flex={'1 1 auto'} {...mainMiddleProps}>
                {main}
              </Box>
            ) : (
              main
            )}
            {mainBottom && (
              <Box flex={'0 0 auto'} {...mainBottomProps}>
                {mainBottom}
              </Box>
            )}
          </Flex>
        )}
        {right && (
          <Box flex={'0 0 auto'} {...rightProps}>
            {right}
          </Box>
        )}
      </Flex>
      {bottom && <Box {...bottomProps}>{bottom}</Box>}
    </Box>
  );
};

Layout.propTypes = {
  top: PropTypes.node,
  main: PropTypes.node,
  left: PropTypes.node,
  right: PropTypes.node,
  bottom: PropTypes.node,
  topProps: PropTypes.object,
  mainProps: PropTypes.object,
  leftProps: PropTypes.object,
  rightProps: PropTypes.object,
  bottomProps: PropTypes.object,
  mainTopProps: PropTypes.object,
  mainBottomProps: PropTypes.object,
  mainMiddleProps: PropTypes.object,
  innerContainerProps: PropTypes.object,
  outerContainerProps: PropTypes.object,
};

export default Layout;
